// 控制弹窗显示
export default {
	namespaced: true,
	state: {
		queue: [], // 弹窗队列
		visible: false, // 是否已经有弹窗展示
		order: ['modal4', 'modal3', 'modal2', 'modal1'], // 权重
	},
	mutations: {
		add(state, info) {
			const { queue, order } = state;
			const orderIndex = order.findIndex((item) => item == info.type);
			let len = queue.length;
			// 找到合适的位置插入
			for (let i = 0; i < len; i++) {
				const curModal = queue[i];
				const curOrderIndex = order.findIndex((item) => item == curModal.type);
				if (curOrderIndex > orderIndex) {
					queue.splice(i, 0, info);
					return;
				} else if (curModal.type == info.type) {
					queue.splice(i, 0, info);
					return;
				}
			}
			queue.push(info);
		},
		// 弹出第一个弹窗
		pop(state) {
			const queue = state.queue;
			let len = queue.length;
			if (len > 0) {
				const { instance } = queue.shift();
				instance.show();
				state.visible = true;
			} else {
				state.visible = false;
			}
		},
	},
	actions: {
		/**
		 * 往队列添加弹窗，并弹出队列的第一个弹窗
		 * @param {Object} info 组件的实例、类型等信息
		 * @param {Object} info.instance 组件的实例
		 * @param {String} info.type 组件的权重名，对应order
		 * @param {Boolean} info.show 是否立即展示
		 */
		addModal(ctx, info = {}) {
			ctx.commit('add', info);
			if (!ctx.state.visible && info.show) {
				ctx.commit('pop');
			}
		},
		// 下一个弹窗
		nextModal(ctx) {
			ctx.commit('pop');
		},
	},
};
